<template>
  <page-loader v-if="loadingStatus == 'loading'" />
  <div v-else class="contain-section text-start px-0">
    <div class="inner-box">
      <div class="col-sm-12">
        <div class="row d-flex justify-content-center d-flex align-items-center">
          <div class="col-sm-6">
            <h4 class="fw-bolder mb-2 mb-sm-3">
              {{
                traitOverview && traitOverview.content && traitOverview.content.length > 0
                  ? traitOverview.content[0].heading
                  : ""
              }}
            </h4>
            <div
              class="fs-14 text-gry"
              v-html="
                traitOverview && traitOverview.content && traitOverview.content.length > 0
                  ? traitOverview.content[0].text
                  : ''
              "
            ></div>
          </div>
          <div class="col-sm-6">
            <figure class="m-auto">
              <img
                :src="
                  traitOverview &&
                  traitOverview.content &&
                  traitOverview.content.length > 0
                    ? traitOverview.content[0].image[0].url
                    : ''
                "
                alt="Logo"
                class="img-fluid rounded-4"
              />
            </figure>
          </div>
        </div>
      </div>
      <div class="col-sm-12 mt-4">
        <ul class="list-of-action f-choose mb-2 mb-sm-0">
          <li v-for="(content, index) in cmsTraits" :key="index">
            <a
              :class="{ active: activeSection.title === content.title }"
              @click="showSection(content)"
              >{{ content.title }}</a
            >
          </li>
          <!-- <li>
                        <a
                            :class="{ active: activeSection === 'sleeping' }"
                            @click="showSection('sleeping')"
                            >Sleeping Patterns</a
                        >
                    </li>
                    <li>
                        <a
                            :class="{ active: activeSection === 'immune' }"
                            @click="showSection('immune')"
                            >Immune System Benefits</a
                        >
                    </li>
                    <li>
                        <a
                            :class="{ active: activeSection === 'hair' }"
                            @click="showSection('hair')"
                            >Hair Colour and Type</a
                        >
                    </li>
                    <li>
                        <a
                            :class="{ active: activeSection === 'skin' }"
                            @click="showSection('skin')"
                            >Skin Pigmentation & Sun Exposure Reaction</a
                        >
                    </li> -->
        </ul>
      </div>

      <div class="dynamic-section">
        <!-- {{ activeSection }} -->
        <div class="col-sm-12">
          <!-- <div class="banner-box h-400"> -->
          <div class="banner-box new-banner-box-feedback">
            <img class="rounded-4" :src="activeSection.mainImage?.urlHero" alt="Logo" />
          </div>
        </div>
        <div class="col-sm-10">
          <div class="inner-content mb-3">
            <h4 class="fw-bold text-blk mb-2 mb-sm-3">{{ activeSection.title }}</h4>
            <p class="text-gry" v-html="activeSection.text"></p>
          </div>
        </div>
        <div class="col-sm-12">
          <div class="row w-full d-flex justify-content-between align-items-center mb-3">
              <div class="col-sm-8">
                <h4 class="fw-bold text-blk mb-1">Your Result</h4>
                <p class="text-gry mb-0 fs-14">
                    {{ archaicResult?.traits[activeSection.slug]?.total?.totalPhenotype }}
                </p>
              </div>
              <div class="col-auto ml-auto mt-3 mt-sm-0">
                <button class="traits-btn cursor-text" :class="shortResult(archaicResult?.traits[activeSection.slug]?.total?.totalPhenotypeSlug).bgColor || 'Not-Found'">{{ shortResult(archaicResult?.traits[activeSection.slug]?.total?.totalPhenotypeSlug).friendlyName || 'Not Found' }}</button>
              </div>
            </div>
        </div>
        <div class="col-sm-12 custom-table">
          <!-- <div v-if="Object.keys(archaicResult.subtraits).length > 1">
                        The {{ cmsData.heading }} trait is made up of
                        {{ Object.keys(archaicResult?.subtraits).length }} subtraits
                    </div>
                    {{ archaicResult.traits[activeSection.slug]?.subtraits }}
                    <div
                        v-for="(subtraitDetails, name) in archaicResult.traits[activeSection.slug]
                            ?.subtraits"
                        :key="name"
                    >
                        <h4>{{ name }}</h4>
                        <p>{{ subtraitDetails.total.totalPhenotype }}</p>
                        <div class="bg-white shadow-key rounded">
                            <div class="px-6 py-4 flex text-grey-500 text-sm justify-center">
                                <div class="w-1/5 text-center">Gene</div>
                                <div class="w-1/5 text-center">RSID</div>
                                <div class="w-1/5 text-center">Locus</div>
                                <div class="w-1/5 text-center">Genotype</div>
                                <div class="w-1/5 text-center">Phenotype</div>
                            </div>
                            <div
                                v-for="(details, snp) in subtraitDetails.snps"
                                :key="snp"
                                class="px-6 bg-grey-50 pt-6 rounded-b"
                            >
                                <div class="flex pb-6">
                                    <div class="w-1/5 text-center">{{ details.gene }}</div>
                                    <div class="w-1/5 text-center">{{ snp }}</div>
                                    <div class="w-1/5 text-center">{{ details.locus }}</div>
                                    <div class="w-1/5 text-center">{{ details.genotype }}</div>
                                    <div class="w-1/5 text-center capitalize">
                                        {{ details.phenotype }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div> -->
          <div
            v-for="(subtraitDetails, name) in archaicResult.traits[activeSection.slug]
              ?.subtraits"
            :key="name"
          >
            <h6 class="fw-bold text-blk mb-1">{{ name }}</h6>
            <p class="text-gry mb-0 fs-14 mb-3">
              {{ subtraitDetails.total.totalPhenotype }}
            </p>
            <table class="table">
              <thead class="table-light">
                <tr>
                  <th scope="col">Gene</th>
                  <th scope="col">RSID</th>
                  <th scope="col">Locus</th>
                  <th scope="col">Genotype</th>
                  <th scope="col">Phenotype</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(details, snp) in subtraitDetails.snps" :key="snp">
                  <td>{{ details.gene }}</td>
                  <td>{{ snp }}</td>
                  <td>{{ details.locus }}</td>
                  <td>{{ details.genotype }}</td>
                  <td>{{ details.phenotype }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div class="dynamic-section" v-if="activeSection === 'sleeping'">
        <div class="col-sm-12">
          <div class="banner-box h-400">
            <!-- <img src="../../../assets/images/ancetry/img26.png" alt="Logo" /> -->
          </div>
        </div>
        <div class="col-sm-10">
          <div class="inner-content mb-3">
            <h4 class="fw-bold text-blk mb-2 mb-sm-3">Immune System Benefits</h4>
            <p class="text-gry">
              A number of Immune System genes for which genetic variants have been
              attributed to Neanderthal DNA. These are STAT2, OAS1,OAS2, OAS3, TLR1, TLR6,
              TLR10 HLA & TNFAIP3. It is thought that these variants aided in human
              adaptation to non-African environments (Racimo et al., 2015), specifically
              newly encountered diseases.
            </p>
          </div>
        </div>
        <div class="col-sm-12">
          <div class="row w-full d-flex justify-content-between">
            <div class="col-sm-10">
              <h5 class="fw-bold text-blk mb-2 mb-sm-3">Your Result</h5>
              <p class="text-gry fs-14">
                Your genotype for SNP rs5743618 is associated with a significant overall
                decrease in the expression of inflammatory response genes. Your genotype
                for SNP rs17544225 is not associated with a higher autoimmune disease
                risk. You are not likely to have an increased expression of TLR1 (involved
                in pathogen recognition and innate immunity).
              </p>
            </div>
            <div class="col-auto ml-auto">
              <button class="positive-btn">Positive</button>
            </div>
          </div>
        </div>
        <div class="col-sm-12 mt-2">
          <h4 class="fw-medium fs-6 text-blk mt-4 mt-sm-0">
            The Immune System Benefits trait is made up of 3 subtraits
          </h4>
        </div>

        <div class="col-sm-12 mt-4">
          <div class="row">
            <div class="col-sm-12">
              <h5 class="fw-bold fs-6 text-blk">Inflammatory Response</h5>
              <p class="fs-14">
                Your genotype for SNP rs5743618 is associated with a significant overall
                decrease in the expression of inflammatory response genes.
              </p>
            </div>
            <div class="col-sm-12 custom-table">
              <table class="table">
                <thead class="table-light">
                  <tr>
                    <th scope="col">Gene</th>
                    <th scope="col">RSID</th>
                    <th scope="col">Locus</th>
                    <th scope="col">Genotype</th>
                    <th scope="col">Phenotype</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>EPAS1</td>
                    <td>rs115321619</td>
                    <td>2:46567916</td>
                    <td>GG</td>
                    <td>Negative</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div class="col-sm-12 mt-4">
          <div class="row">
            <div class="col-sm-12">
              <h5 class="fw-bold fs-6">Autoimmunity</h5>
              <p class="fs-14">
                Your genotype for SNP rs17544225 is not associated with a higher
                autoimmune disease risk.
              </p>
            </div>
            <div class="col-sm-12 custom-table">
              <table class="table">
                <thead class="table-light">
                  <tr>
                    <th scope="col">Gene</th>
                    <th scope="col">RSID</th>
                    <th scope="col">Locus</th>
                    <th scope="col">Genotype</th>
                    <th scope="col">Phenotype</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>1</td>
                    <td>rs115321619</td>
                    <td>2:46567916</td>
                    <td>GG</td>
                    <td>Negative</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div class="col-sm-12 mt-4">
          <div class="row">
            <div class="col-sm-12">
              <h5 class="fw-bold fs-6">Pathogen Recognition</h5>
              <p class="fs-14">
                You are not likely to have an increased expression of TLR1 (involved in
                pathogen recognition and innate immunity).
              </p>
            </div>
            <div class="col-sm-12 custom-table">
              <table class="table">
                <thead class="table-light">
                  <tr>
                    <th scope="col">Gene</th>
                    <th scope="col">RSID</th>
                    <th scope="col">Locus</th>
                    <th scope="col">Genotype</th>
                    <th scope="col">Phenotype</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>1</td>
                    <td>rs115321619</td>
                    <td>2:46567916</td>
                    <td>GG</td>
                    <td>Negative</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <div class="dynamic-section" v-if="activeSection === 'immune'">
        <h5 class="text-center mt-5 mb-5">Content not available</h5>
      </div>

      <div class="dynamic-section" v-if="activeSection === 'hair'">
        <h5 class="text-center mt-5 mb-5">Content not available</h5>
      </div>

      <div class="dynamic-section" v-if="activeSection === 'skin'">
        <h5 class="text-center mt-5 mb-5">Content not available</h5>
      </div>
    </div>
  </div>
</template>
<script>
import "../../styles/pages/ancentry/recent-ancetry.scss";
import { getArchaicTraits, getArchaicTrait } from "@/services/archaic";
import { ref, onMounted } from "vue";
const dict = {
    untested: {
        bgColor: "untested-btn-bg",
        friendlyName: "Not found",
    },
    negative: {
        bgColor: "negative-btn-bg",
        friendlyName: "Negative",
    },
    positive: {
        bgColor: "positive-btn-bg",
        friendlyName: "Positive",
    },
};
export default {
  name: "ArchaicTraits",
  props: {
    archaicResult: Object,
  },
  // eslint-disable-next-line vue/no-setup-props-destructure
  setup({ archaicResult }) {
    const loadingStatus = ref("loading");
    const traitOverview = ref({});
    let activeSection = ref("");
    const cmsTraits = ref([]);

    function showSection(section) {
      activeSection.value = section;
      console.log(activeSection);
    }
    onMounted(async () => {
      const traitNames = Object.keys(archaicResult.traits);

      // traitOverview.value = await getArchaicTraits();
      // loadStatus.value = "loaded";
      const promiseArr = traitNames.map((traitName) => getArchaicTrait(traitName));
      cmsTraits.value = await Promise.all(promiseArr);
      traitOverview.value = await getArchaicTraits();
      activeSection.value = cmsTraits.value[0];
      loadingStatus.value = "loaded";
    });
    return { activeSection, loadingStatus, traitOverview, cmsTraits, showSection };
  },
  computed: {
    shortResult() {
        return (slug) => {
            if (!slug || slug.indexOf('_') === -1) {
                return {};
            }
            const key = slug.substring(slug.indexOf('_') + 1);
            return dict[key] || {};
        };
    }
    },
};
</script>
